export default __webpack_public_path__ + "static/media/Marta.3b805242.PNG";